import { useDashboard } from '@/hooks/useDashboard';

interface MobileStatusBarProps {
  serviceCount: number;
  healthyCount: number;
  incidentCount: number;
}

export function MobileStatusBar({ serviceCount, healthyCount, incidentCount }: MobileStatusBarProps) {
  const { lastRefresh, isOnline } = useDashboard();
  const age = lastRefresh ? `${Math.round((Date.now() - lastRefresh.getTime()) / 1000)}s` : '—';

  return (
    <div
      data-testid="ops-mobile-status-bar"
      className="md:hidden sticky top-0 z-40 bg-slate-950/90 backdrop-blur border-b border-slate-800 px-4 py-2 flex items-center gap-3 text-xs"
    >
      <span className={`w-2 h-2 rounded-full ${healthyCount === serviceCount ? 'bg-green-500' : 'bg-amber-500'}`} />
      <span data-testid="ops-mobile-healthy-count" className="text-slate-300">{healthyCount}/{serviceCount} healthy</span>
      <span className="text-slate-600">|</span>
      <span
        data-testid="ops-mobile-incident-count"
        className={incidentCount > 0 ? 'text-red-400' : 'text-slate-300'}
      >
        {incidentCount} open
      </span>
      <span className="ml-auto text-slate-400">{isOnline ? age : 'offline'}</span>
    </div>
  );
}
